// extracted by mini-css-extract-plugin
export default {"productGallery":"yP-z","infoAboveGallery":"zP-z","inQuickShop":"AP-z"};